import React from 'react'
import moment from 'moment'
import { makeStyles, Grid, Button } from '@material-ui/core'
import { Fragment } from 'react'
import ANTET_INSTITUTIE from '../../Common/ANTET_INSTITUTIE'
import Field from '../../Common/Field'
import { getSetting } from '../../../../lib/settings'
import Antet2022 from '../../Common/Antet2022'
import SemnaturiPrimarSecretarConsilier from '../../Common/SemnaturiPrimarSecretarConsilier'


const useStyles = makeStyles(theme => ({
    text: { fontFamily: "Roboto", fontSize: "0.8rem", fontWeight: "400", textAlign: "justify", textJustify: "inter-word" },
    card: {
        border: `1px solid ${theme.palette.grey[400]}`, padding: theme.spacing(1), marginTop: 0, boxShadow: "none",
        "&& :hover": { background: theme.palette.grey[300] }
    }
}))

export default function TplPv(props) {
    const classes = useStyles()
    const dosar = props.data
    const cod = props.cod
    return (
        <div>
            {dosar && (
                <Grid
                    container alignItems="flex-start"
                    style={{ border: "0px solid red" }}
                    className={classes.text} >
                    

                     <Grid item xs={12} align="right">
                       Anexa nr.12<br/>Anexa nr. 1L la normele metodologice

                    </Grid>
                    <Grid item xs={12}>
                        <Antet2022 data={dosar} />
                    </Grid>
                    <Grid item xs={12} align="right" style = {{paddingTop:"5px"}}>
                       
                        Nr.înreg. {dosar.anexe[cod]['pv'].nr} / {moment(dosar.anexe[cod]['pv'].dt).format("DD.MM.YYYY")}
                    </Grid>
                    <Grid item xs={12} align="center">
                        <h4>PROCES-VERBAL<br/>de anulare a procedurii </h4>

                        <h4> </h4>
                    </Grid>

                    <Grid item xs = {12}>
                        Încheiat astăzi, {moment(dosar.anexe[cod]['pv'].dt).format("DD.MM.YYYY")}, în conformitate cu prevederile art. 7^1 alin. (1) din Legea nr. 17/2014 privind unele măsuri de reglementare a vânzării terenurilor agricole situate în extravilan și de modificare a Legii nr. 268/2001 privind privatizarea societăților ce dețin în administrare terenuri proprietate publică și privată a statului cu destinație agricolă și înființarea Agenției Domeniilor Statului, cu modificările și completările ulterioare, și cu dispozițiile art. 3 lit. r) și art. 9 alin. (4) din Normele metodologice privind exercitarea de către Ministerul Agriculturii și Dezvoltării Rurale a atribuțiilor ce îi revin pentru aplicarea titlului I din Legea nr. 17/2014 privind unele măsuri de reglementare a vânzării terenurilor agricole situate în extravilan și de modificare a Legii nr. 268/2001 privind privatizarea societăților ce dețin în administrare terenuri proprietate publică și privată a statului cu destinație agricolă și înființarea Agenției Domeniilor Statului, aprobate prin Ordinul viceprim-ministrului, ministrul agriculturii și dezvoltării rurale, al viceprimministrului, ministrul dezvoltării regionale și administrației publice, al ministrului apărării naționale și al viceprim-ministrului, ministrul culturii, nr. 719/740/M.57/2.333/2014, cu modificările și completările ulterioare.
                    </Grid>

                    <Grid item xs = {12}>
                        Ca urmare a faptului că înaintea împlinirii termenului prevăzut la art. 6 alin. (2) din Legea nr. 17/2014, cu modificările și completările ulterioare, respectiv termenul de 45 de zile lucrătoare, vânzătorul {' '}
                        {dosar.ofertanti.map((e, i) => (
                            <Fragment key={i}>
                                <Field>{e.titular.name}</Field>
                                {e.mandatar && <span> -{' '}
                                                            prin mandatar <Field>{e.mandatar.name}</Field></span>}
                                {i + 1 < dosar.ofertanti.length && ", "}
                            </Fragment>
                        ))}
                         , prin care solicită retragerea ofertei de vânzare nr. {' '}
                         {dosar.nr} din data de {moment(dosar.dt).format("DD.MM.YYYY")},                    
                    </Grid>
                    <Grid item xs ={12}>
                        prin prezentul proces-verbal s-a constatat anularea procedurii prevăzute de Legea nr. 17/2014, cu modificările și completările ulterioare, pentru oferta de vânzare {dosar.nr} din data de {moment(dosar.dt).format("DD.MM.YYYY")}, depusă de către {' '}
                        {dosar.ofertanti.map((e, i) => (
                            <Fragment key={i}>
                                <Field>{e.titular.name}</Field>
                                {i + 1 < dosar.ofertanti.length && ", "}
                            </Fragment>
                        ))} {' '}
                         în calitate de vânzător/vânzătoare, proprietar/coproprietar al terenului agricol situat în extravilanul localității 
                         {dosar?.anexe?.terenCfLoc || "---"}, {' '}
                         tarlaua nr.  <strong>{dosar?.anexe?.terenTarla || "---"}</strong>, {' '}
                         parcela nr.  <strong>{dosar?.anexe?.terenParcela || "---"}</strong>, {' '}
                         categoria de folosință  <strong>{dosar?.anexe?.terenCategorie || "---"}</strong>, {' '}
                         identificat prin nr. cadastral  <strong>{dosar?.anexe?.terenNrCadastral || "---"}</strong>, {' '}
                         și număr carte funciară  <strong>{dosar?.anexe?.terenCf || "---"}</strong>, {' '}
                         în suprafață de  <strong>{dosar?.anexe?.terenHa || "---"}</strong>, {' '}
                         ha, reprezentând cota-parte  <strong>{dosar?.anexe?.cotaParte || "---"}</strong>, {' '}
                         județul  <strong>{dosar?.anexe?.terenJud || "---"}</strong>, {' '}
                         oferit spre vânzare la prețul de  <strong>{dosar?.anexe?.terenPret || "---"}</strong>, lei.<br/>
                        Prezentul proces-verbal se eliberează, în original, vânzătorului și se comunică, în copie, structurii centrale/structurii teritoriale {' '}
                        <strong>{dosar?.company?.jud}</strong> și Agenției Domeniilor Statului.
                    </Grid>

                    

                    <Grid item xs={12} align="center">
                        <br/>
                        <SemnaturiPrimarSecretarConsilier data = {dosar}/>
                    </Grid>
                </Grid>
            )}
        </div>
    )
}
